import { render } from "./ErrorSquadDutyBlock.vue?vue&type=template&id=2848c652"
import script from "./ErrorSquadDutyBlock.vue?vue&type=script&lang=js"
export * from "./ErrorSquadDutyBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__